import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import css from './style.scss';

//Note : This is a common modal component intraduced for the skip trace and dialer campingns common modal with #EFF2F6 background 

const BODY_CLASS_NAME = 'bodyModal';

const CommonModal = ({
  title,
  children,
  footer,
  onClose,
  hideBodyPadding = false,
  className,
  closeOnBackdrop = false,
}) => {
  const modalRef = useRef(null);

  useEffect(() => {
    document.body.classList.add(BODY_CLASS_NAME);

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };

    document.addEventListener('keydown', handleKeyDown, true);
    return () => {
      document.body.classList.remove(BODY_CLASS_NAME);
      document.removeEventListener('keydown', handleKeyDown, true);
    };
  }, []);

  return (
    <div
      className={css.modalOverlay}
      onMouseDown={(e) => {
        e.stopPropagation();
        if (closeOnBackdrop && e.target === e.currentTarget) {
          onClose?.();
        }
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        className={css.modalWrapper}
        onMouseDown={(e) => {
          e.stopPropagation();
          if (closeOnBackdrop && e.target === e.currentTarget) {
            onClose?.();
          }
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div
          ref={modalRef}
          className={classNames(css.modalBox, className)}
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
        >
          {title && (
            <div className={css.modal_header}>
              <h3 className={css.modal_title}>{title}</h3>
            </div>
          )}

          <div
            className={classNames(css.modal_body, {
              [css.noPadding]: hideBodyPadding,
            })}
          >
            {children}
          </div>

          {footer && <div className={css.modal_footer}>{footer}</div>}
        </div>
      </div>
    </div>
  );
};

export default CommonModal;
